var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOpenTicketIc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.96296 4.00001C9.15004 3.99695 11.2609 4.78852 12.8889 6.22222V20C11.2609 18.5663 9.15004 17.7748 6.96296 17.7778C5.57451 17.7778 4.88028 17.7778 4.57356 17.5815C4.38942 17.4636 4.31419 17.3884 4.19632 17.2042C4 16.8975 4 16.3503 4 15.2559V7.02508C4 5.75594 4 5.12137 4.48777 4.60699C4.97554 4.0926 5.47487 4.06606 6.47353 4.01298C6.63556 4.00436 6.79874 4.00001 6.96296 4.00001Z",
    stroke: "#172B4D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.8149 4.00001C16.6278 3.99695 14.5169 4.78852 12.8889 6.22222V20C14.5169 18.5663 16.6278 17.7748 18.8149 17.7778C20.2033 17.7778 20.8975 17.7778 21.2042 17.5815C21.3884 17.4636 21.4636 17.3884 21.5815 17.2042C21.7778 16.8975 21.7778 16.3503 21.7778 15.2559V7.02508C21.7778 5.75594 21.7778 5.12137 21.2901 4.60699C20.8022 4.0926 20.303 4.06606 19.3043 4.01298C19.1423 4.00436 18.9791 4.00001 18.8149 4.00001Z",
    stroke: "#6929E2",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpenTicketIc);
export default __webpack_public_path__ + "static/media/open_ticket_ic.89330538b14337cf94234f202358b0f6.svg";
export { ForwardRef as ReactComponent };